import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { mdiBellOffOutline, mdiBellOutline } from "@mdi/js";

import { SvgIconRegistry } from "@dffedb/util";

import { NotificationDialogComponent } from "./notification-dialog.component";
import { PushNotificationService } from "./push-notification.service";

@Component({
    selector: "eforsyning-notification-dialog-trigger",
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule],
    templateUrl: "./notification-dialog-trigger.component.html",
    styleUrls: ["./notification-dialog-trigger.component.scss"]
})
export class NotificationDialogTriggerComponent {
    private readonly dialog = inject(MatDialog);
    private readonly pushNotificationService = inject(PushNotificationService);

    public readonly canUsePushNotifications = this.pushNotificationService.canUsePushNotifications();
    public notificationsEnabled = false;

    constructor() {
        const svgIconRegistry = inject(SvgIconRegistry);
        svgIconRegistry.registerIcon(mdiBellOutline, "notification-bell");
        svgIconRegistry.registerIcon(mdiBellOffOutline, "notification-bell-off");
        this.refreshEnabledState();
    }

    public get bellIcon(): string {
        return this.notificationsEnabled ? "notification-bell" : "notification-bell-off";
    }

    public openDialog(event?: Event): void {
        event?.stopPropagation();
        if (!this.canUsePushNotifications) {
            return;
        }

        this.dialog
            .open(NotificationDialogComponent, {
                width: "480px",
                maxWidth: "calc(100vw - 24px)",
                autoFocus: false,
                restoreFocus: true
            })
            .afterClosed()
            .subscribe(() => this.refreshEnabledState());
    }

    private refreshEnabledState(): void {
        this.notificationsEnabled =
            this.pushNotificationService.isNotificationEnabled() && !this.pushNotificationService.hasUnsubscribedFromNotifications();
    }
}
